import React from "react";
import arrowLeft from "../../assets/images/arrowLeft.png";
import arrowRight from "../../assets/images/arrowRight.png";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useParams } from "react-router-dom";

const CustomLink = ({ to, children }) => {
  const direction = useLanguageDirection();
  const { lang } = useParams();
  const currentLang = lang || localStorage.getItem("language") || "ar";

  const isExternal = to.startsWith("http");

  const finalUrl = isExternal
    ? to
    : `/${currentLang}${to.startsWith("/") ? to : "/" + to}`;

  const handleClick = (e) => {
    e.preventDefault();
    window.location.href = finalUrl; 
  };

  return (
    <a
      href={finalUrl}
      onClick={handleClick}
      className="flex items-center font-medium text-white duration-300 text-start text-xxs lg:text-sm hover:text-custom-yellow"
    >
      <img
        src={direction === "rtl" ? arrowLeft : arrowRight}
        alt="arrow"
        className="mx-2"
      />
      {children}
    </a>
  );
};

export default CustomLink;
